import {
  CaseSummaryFragmentFragment,
  TestRuleQuery,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { Case } from "src/types/case";
import { Rule } from "src/types/rule";

import { mapToCaseSummary } from "./case.mappers";
import { mapToRule } from "./rule.mappers";

export type ExecutionResult = {
  rule: Rule;
  matched: boolean;
  relatedCases: Case[];
};

/**
 * Maps a TestRuleResult from GraphQL to ExecutionResult
 * Note: relatedCases uses CaseSummaryFragment, so we map to CaseSummary
 * and then extend it to Case with default values for missing fields
 */
export const mapToExecutionResult = (
  testRuleResult: TestRuleQuery["testRule"]
): ExecutionResult => {
  return {
    rule: mapToRule(testRuleResult.rule),
    matched: testRuleResult.matched,
    relatedCases: testRuleResult.relatedCases.map((caseFragment) =>
      mapToCaseFromCaseSummary(caseFragment)
    ),
  };
};

/**
 * Maps a CaseSummaryFragment to a Case type
 * Since the fragment doesn't include all Case fields, we provide defaults
 */
const mapToCaseFromCaseSummary = (caseFragment: CaseSummaryFragmentFragment): Case => {
  const caseSummary = mapToCaseSummary(caseFragment);

  // Extend CaseSummary to Case with default values for missing fields
  return {
    ...caseSummary,
    alertStatus: "initial", // Default value since not in fragment
    configurableType: {
      code: caseSummary.typeCode,
      name: caseSummary.typeCode, // Default to typeCode as name
    },
    blacklistedIdentifiers: [], // Empty array since not in fragment
    request: caseSummary.request,
    alerts: [],
    executionResults: [],
    elementLists: [],
  };
};
